import { parsedUserAgent } from '@100mslive/react-sdk';

export const defaultAudioList = [
    {
        name: 'Audio1',
        id: 'audio1',
        metadata: {
            description: 'Artist1',
        },
        url: 'https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio1.mp3',
        type: 'audio',
    },
];

export const defaultVideoList = [
    {
        name: 'Video1',
        id: 'video1',
        metadata: {
            description: 'Artist1',
        },
        url: 'https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/video1.mp4',
        type: 'video',
    },
];

export const DEFAULT_HLS_ROLE_KEY = 'HLS_VIEWER_ROLE';
export const DEFAULT_HLS_VIEWER_ROLE = 'hls-viewer';
export const DEFAULT_WAITING_VIEWER_ROLE = 'waiting-room';
export const QUERY_PARAM_SKIP_PREVIEW = 'skip_preview';
export const QUERY_PARAM_SKIP_PREVIEW_HEADFUL = 'skip_preview_headful';
export const QUERY_PARAM_NAME = 'name';
export const QUERY_PARAM_VIEW_MODE = 'ui_mode';
export const QUERY_PARAM_AUTH_TOKEN = 'auth_token';
export const QUERY_PARAM_PREVIEW_AS_ROLE = 'preview_as_role';
export const UI_MODE_ACTIVE_SPEAKER = 'activespeaker';
export const UI_MODE_GRID = 'grid';
export const MAX_TOASTS = 5;
export const RTMP_RECORD_RESOLUTION_MIN = 480;
export const RTMP_RECORD_RESOLUTION_MAX = 1280;
export const RTMP_RECORD_DEFAULT_RESOLUTION = {
    width: 1280,
    height: 720,
};
export const EMOJI_REACTION_TYPE = 'EMOJI_REACTION';

export const CHAT_SELECTOR = {
    PEER_ID: 'peer_id',
    ROLE: 'role',
};

export const APP_DATA = {
    uiSettings: 'uiSettings',
    chatOpen: 'chatOpen',
    chatSelector: 'chatSelector',
    chatDraft: 'chatDraft',
    appConfig: 'appConfig',
    sidePane: 'sidePane',
    hlsStats: 'hlsStats',
    hlsViewerRole: 'hlsViewerRole',
    waitingViewerRole: 'waitingViewerRole',
    subscribedNotifications: 'subscribedNotifications',
    logo: 'logo',
    tokenEndpoint: 'tokenEndpoint',
    appLayout: 'appLayout',
    hlsStarted: 'hlsStarted',
    rtmpStarted: 'rtmpStarted',
    recordingStarted: 'recordingStarted',
    embedConfig: 'embedConfig',
    pdfConfig: 'pdfConfig',
    pinnedTrackId: 'pinnedTrackId',
    dropdownList: 'dropdownList',
    widgetState: 'widgetState',
};

export const UI_SETTINGS = {
    isAudioOnly: 'isAudioOnly',
    isHeadless: 'isHeadless',
    maxTileCount: 'maxTileCount',
    uiViewMode: 'uiViewMode',
    showStatsOnTiles: 'showStatsOnTiles',
    enableAmbientMusic: 'enableAmbientMusic',
    mirrorLocalVideo: 'mirrorLocalVideo',
    activeSpeakerSorting: 'activeSpeakerSorting',
    hideLocalVideo: 'hideLocalVideo',
};

export const WIDGET_STATE = {
    pollInView: 'pollInView',
    view: 'view',
};

export const WIDGET_VIEWS = {
    LANDING: 'LANDING',
    CREATE_POLL_QUIZ: 'CREATE_POLL_QUIZ',
    CREATE_QUESTIONS: 'CREATE_QUESTIONS',
    VOTE: 'VOTE',
    RESULTS: 'RESULTS',
};

export const SIDE_PANE_OPTIONS = {
    PARTICIPANTS: 'Participants',
    CHAT: 'Chat',
    STREAMING: 'STREAMING',
    TILES: 'TILES',
    SCREEN_TILES: 'SCREEN_TILES',
    WIDGET: 'WIDGET',
};

export const SUBSCRIBED_NOTIFICATIONS = {
    PEER_JOINED: 'PEER_JOINED',
    PEER_LEFT: 'PEER_LEFT',
    METADATA_UPDATED: 'METADATA_UPDATED',
    NEW_MESSAGE: 'NEW_MESSAGE',
    ERROR: 'ERROR',
};

export const CREATE_ROOM_DOC_URL = 'https://github.com/100mslive/100ms-web/wiki/Creating-and-joining-a-room';
export const HLS_TIMED_METADATA_DOC_URL =
    'https://www.100ms.live/docs/javascript/v2/how--to-guides/record-and-live-stream/hls/hls-timed-metadata';

export const REMOTE_STOP_SCREENSHARE_TYPE = 'REMOTE_STOP_SCREENSHARE';

export const isChrome = parsedUserAgent.getBrowser()?.name?.toLowerCase() === 'chrome';
export const isFirefox = parsedUserAgent.getBrowser()?.name?.toLowerCase() === 'firefox';
export const isSafari = parsedUserAgent.getBrowser()?.name?.toLowerCase() === 'safari';
export const isIOS = parsedUserAgent.getOS()?.name?.toLowerCase() === 'ios';
export const isMacOS = parsedUserAgent.getOS()?.name?.toLowerCase() === 'mac os';
export const isAndroid = parsedUserAgent.getOS()?.name?.toLowerCase() === 'android';
export const isIPadOS =
    navigator?.maxTouchPoints && navigator?.maxTouchPoints > 2 && navigator?.userAgent?.match(/Mac/);

export const FEATURE_LIST = {
    AUDIO_ONLY_SCREENSHARE: 'audioscreenshare',
    AUDIO_PLAYLIST: 'audioplaylist',
    VIDEO_PLAYLIST: 'videoplaylist',
    EMOJI_REACTION: 'emojireaction',
    AUDIO_PLUGINS: 'audioplugins',
    VIDEO_PLUGINS: 'videoplugins',
    WHITEBOARD: 'whiteboard',
    CHANGE_NAME: 'changename',
    FULLSCREEN: 'fullscreen',
    PICTURE_IN_PICTURE: 'pip',
    STARTS_FOR_NERDS: 'statsfornerds',
    EMBED_URL: 'embedurl',
    BRB: 'brb',
    HAND_RAISE: 'handraise',
    CHAT: 'chat',
    PIN_TILE: 'pintile',
};

export const SESSION_STORE_KEY = {
    TRANSCRIPTION_STATE: 'transcriptionState',
    PINNED_MESSAGE: 'pinnedMessage',
    SPOTLIGHT: 'spotlight',
};

export const INTERACTION_TYPE = {
    POLL: 'Poll',
    QUIZ: 'Quiz',
};

export const QUESTION_TYPE_TITLE = {
    'single-choice': 'Single Choice',
    'multiple-choice': 'Multiple Choice',
    // "short-answer": "Short Answer",
    // "long-answer": "Long Answer",
};

export const QUESTION_TYPE = {
    SINGLE_CHOICE: 'single-choice',
    MULTIPLE_CHOICE: 'multiple-choice',
    // SHORT_ANSWER: "short-answer",
    // LONG_ANSWER: "long-answer",
};

export const PDF_SHARING_OPTIONS = {
    FROM_YOUR_COMPUTER: 'From your Computer',
    FROM_A_URL: 'From a URL',
};

export const ASSET_NAMES = {
    BOT_GIF: 'botGif.gif',
    RECORDING_ICON: 'recordingIcon.svg',
    LOGO: 'logo.svg',
    INCRUITER_LOGO: 'incruiter_logo.svg',
    TECHNICAL_ERROR: 'technicalError.svg',
    HYPERLINK: 'hyperlink.svg',
    SKIP_FORWARD: 'skip-forward.svg',
    NEXT_QUESTION: 'next-question.svg',
    NOT_SUPPORTED: 'not-supported.svg',
    RUN_CODE: 'run-code.svg',
    SUBMIT_ICON: 'submit-icon.svg',
};

export const GENERAL_ERROR = 'Something went wrong';

export const AUDIO_NOT_DETECTED = 'Please ensure your microphone is working and read the text again.';

export const QUESTION_TYPES = {
    GLOBAL: 'global',
    CUSTOM: 'custom',
    CODING: 'coding',
    AI_GENERATED: 'ai-generated',
    MCQ: {
        LOGICAL: 'logical_reasoning',
        QUANTITATIVE: 'quantitative',
        VERBAL: 'verbal_reasoning',
        NUMBER: 'number_system',
    },
};

export const QUESTION = {
    QUESTION: 'question',
    EDITABLE_ANSWER: 'editableAnswer',
    ANSWER: 'answer',
    QUESTION_TYPE: 'questionType',
    TIME_TO_PREPARE: 'timeToPrepare',
    TIME_TO_ANSWER: 'timeToAnswer',
    IS_EDITABLE: 'isEditable',
    EDITABLE_QUESTION: 'editableQuestion',
    ERROR: 'error',
    DIFFICULTY_LEVEL: 'difficultyLevel',
    CODE_DURATION: 'codeDuration',
};

export const getCodeLanguages = () => [
    { value: 45, label: 'Assembly (NASM 2.14.02)' },
    { value: 46, label: 'Bash (5.0.0)' },
    { value: 47, label: 'Basic (FBC 1.07.1)' },
    { value: 104, label: 'C (Clang 18.1.8)' },
    { value: 75, label: 'C (Clang 7.0.1)' },
    { value: 103, label: 'C (GCC 14.1.0)' },
    { value: 48, label: 'C (GCC 7.4.0)' },
    { value: 49, label: 'C (GCC 8.3.0)' },
    { value: 50, label: 'C (GCC 9.2.0)' },
    { value: 76, label: 'C++ (Clang 7.0.1)' },
    { value: 105, label: 'C++ (GCC 14.1.0)' },
    { value: 52, label: 'C++ (GCC 7.4.0)' },
    { value: 53, label: 'C++ (GCC 8.3.0)' },
    { value: 54, label: 'C++ (GCC 9.2.0)' },
    { value: 86, label: 'Clojure (1.10.1)' },
    { value: 51, label: 'C# (Mono 6.6.0.161)' },
    { value: 77, label: 'COBOL (GnuCOBOL 2.2)' },
    { value: 55, label: 'Common Lisp (SBCL 2.0.0)' },
    { value: 90, label: 'Dart (2.19.2)' },
    { value: 56, label: 'D (DMD 2.089.1)' },
    { value: 57, label: 'Elixir (1.9.4)' },
    { value: 58, label: 'Erlang (OTP 22.2)' },
    { value: 44, label: 'Executable' },
    { value: 87, label: 'F# (.NET Core SDK 3.1.202)' },
    { value: 59, label: 'Fortran (GFortran 9.2.0)' },
    { value: 60, label: 'Go (1.13.5)' },
    { value: 95, label: 'Go (1.18.5)' },
    { value: 88, label: 'Groovy (3.0.3)' },
    { value: 61, label: 'Haskell (GHC 8.8.1)' },
    { value: 96, label: 'JavaFX (JDK 17.0.6, OpenJFX 22.0.2)' },
    { value: 91, label: 'Java (JDK 17.0.6)' },
    { value: 62, label: 'Java (OpenJDK 13.0.1)' },
    { value: 63, label: 'JavaScript (Node.js 12.14.0)' },
    { value: 93, label: 'JavaScript (Node.js 18.15.0)' },
    { value: 97, label: 'JavaScript (Node.js 20.17.0)' },
    { value: 102, label: 'JavaScript (Node.js 22.08.0)' },
    { value: 78, label: 'Kotlin (1.3.70)' },
    { value: 64, label: 'Lua (5.3.5)' },
    { value: 89, label: 'Multi-file program' },
    { value: 79, label: 'Objective-C (Clang 7.0.1)' },
    { value: 65, label: 'OCaml (4.09.0)' },
    { value: 66, label: 'Octave (5.1.0)' },
    { value: 67, label: 'Pascal (FPC 3.0.4)' },
    { value: 85, label: 'Perl (5.28.1)' },
    { value: 68, label: 'PHP (7.4.1)' },
    { value: 98, label: 'PHP (8.3.11)' },
    { value: 43, label: 'Plain Text' },
    { value: 69, label: 'Prolog (GNU Prolog 1.4.5)' },
    { value: 70, label: 'Python (2.7.17)' },
    { value: 92, label: 'Python (3.11.2)' },
    { value: 100, label: 'Python (3.12.5)' },
    { value: 71, label: 'Python (3.8.1)' },
    { value: 80, label: 'R (4.0.0)' },
    { value: 72, label: 'Ruby (2.7.0)' },
    { value: 73, label: 'Rust (1.40.0)' },
    { value: 81, label: 'Scala (2.13.2)' },
    { value: 82, label: 'SQL (SQLite 3.27.2)' },
    { value: 83, label: 'Swift (5.2.3)' },
    { value: 74, label: 'TypeScript (3.7.4)' },
    { value: 94, label: 'TypeScript (5.0.3)' },
    { value: 101, label: 'TypeScript (5.6.2)' },
    { value: 84, label: 'Visual Basic.Net (vbnc 0.0.0.5943)' },
];

export const codeLanguageIdMapping = {
    45: null,
    46: null,
    47: null,
    75: 'cpp',
    76: 'cpp',
    48: 'cpp',
    52: 'cpp',
    49: 'cpp',
    53: 'cpp',
    50: 'cpp',
    54: 'cpp',
    86: 'clojure',
    51: 'csharp',
    77: null,
    55: null,
    56: null,
    57: 'elixir',
    58: null,
    44: null,
    87: 'fsharp',
    59: null,
    60: 'go',
    88: null,
    61: null,
    62: 'java',
    63: 'javascript',
    78: 'kotlin',
    64: 'lua',
    89: null,
    79: 'objective-c',
    65: null,
    66: null,
    67: 'pascal',
    85: 'perl',
    68: 'php',
    43: null,
    69: null,
    70: 'python',
    71: 'python',
    80: 'r',
    72: 'ruby',
    73: 'rust',
    81: null,
    82: 'sql',
    83: 'swift',
    74: 'typescript',
    84: null,
    91: 'java',
    92: 'python',
    93: 'javascript',
    90: 'dart',
    104: 'cpp',
    103: 'cpp',
    105: 'cpp',
    95: 'go',
    96: 'java',
    97: 'javascript',
    102: 'javascript',
    98: 'php',
    100: 'python',
    94: 'typescript',
    101: 'typescript',
};

export const DEFAULT_FORM = {
    codeEditor: '',
    language: null,
    input: '',
    output: '',
    editorLang: {},
    prebuilt: '',
    preBuiltFunction: '',
    difficultyLevel: '',
    questionId: '',
    programmingLanguage: '',
};

export const DEFAULT_MCQ_FORM = {
    option_1: '',
    option_2: '',
    option_3: '',
    option_4: '',
    difficultyLevel: null,
};
export const MAX_TILES_FOR_MOBILE = 4;
export const CODE_EDITOR_LANGUAGES_MAP = {
    52: 'c++',
    53: 'c++',
    54: 'c++',
    76: 'c++',
    105: 'c++',
    51: 'c#',
    48: 'c',
    49: 'c',
    50: 'c',
    75: 'c',
    104: 'c',
    103: 'c',
    90: 'dart',
    62: 'java',
    91: 'java',
    96: 'java',
    97: 'javascript',
    102: 'javascript',
    63: 'javascript',
    93: 'javascript',
    71: 'python',
    92: 'python',
    100: 'python',
    68: 'php',
    98: 'php',
    83: 'swift',
    78: 'sql',
    94: 'typescript',
    101: 'typescript',
    74: 'typescript',
};

export const MCQ_TYPE_TEXT = {
    logical_reasoning: 'Logical Reasoning',
    quantitative: 'Quantitative',
    number_system: 'Numerical Reasoning',
    verbal_reasoning: 'Verbal Reasoning',
};

export const LOCAL_MOCK_BACKEND = 'http://172.16.3.169:4004/api/v1/';
export const PUBLIC_PROFILE_URL = 'mock-profile/public-profile';

// Skill type options
export const skillTypeOptions = [
    { value: '', label: 'Select type' },
    { value: 'primary', label: 'Primary' },
    { value: 'secondary', label: 'Secondary' },
];

// Proficiency level options
export const proficiencyLevelOptions = [
    { value: '', label: 'Select Proficiency Level' },
    { value: 'basic', label: 'Basic' },
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'advanced', label: 'Advanced' },
    { value: 'expert', label: 'Expert' },
];
